'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIButton from 'UIComponents/button/UIButton';
import useUserAttribute from '../../hooks/useUserAttribute';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `RichTextLib.newFeatures.${key}`;
const StyledHeader = styled.div.withConfig({
  displayName: "NewFeatureShepherd__StyledHeader",
  componentId: "mq7yz9-0"
})(["font-weight:bold;-webkit-font-smoothing:antialiased;"]);
function NewFeatureShepherd(props) {
  const {
    children,
    className,
    placement,
    width,
    header,
    body,
    getUserAttributes,
    setUserAttribute,
    settingsKey,
    shouldShow
  } = props;
  const [attributeLoaded, hasAttribute, setHasAttribute] = useUserAttribute(getUserAttributes, setUserAttribute, settingsKey, true);
  const showShepherd = shouldShow && attributeLoaded && !hasAttribute;
  return /*#__PURE__*/_jsx(UIPopover, {
    tabIndex: "-1",
    "data-test-id": `new-feature-popover-${settingsKey}`,
    className: className,
    use: "shepherd",
    placement: placement,
    autoPlacement: "horiz",
    open: showShepherd,
    width: width,
    content: {
      header: /*#__PURE__*/_jsx(StyledHeader, {
        children: header
      }),
      body,
      footer: /*#__PURE__*/_jsx(UIButton, {
        onClick: () => setHasAttribute(true),
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('confirm')
        })
      })
    },
    children: children
  });
}
NewFeatureShepherd.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
  settingsKey: PropTypes.string.isRequired,
  getUserAttributes: PropTypes.func.isRequired,
  setUserAttribute: PropTypes.func.isRequired,
  shouldShow: PropTypes.bool,
  width: PropTypes.number,
  placement: PropTypes.string,
  className: PropTypes.string
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
NewFeatureShepherd.defaultProps = {
  width: 350,
  shouldShow: true
};
export default NewFeatureShepherd;